/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsFooter_viewer = {
    readonly visuallySimilarGridItems?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
                readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_similarItems">;
            } | null;
        } | null> | null;
    } | null;
    readonly similarItems: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
                readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_similarItems">;
            } | null;
        } | null> | null;
        readonly pageInfo: {
            readonly hasNextPage: boolean;
            readonly startCursor: string | null;
            readonly endCursor: string | null;
        };
        readonly totalResults: number | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_viewer">;
    readonly " $refType": "PdpRespSimilarItemsFooter_viewer";
};
export type PdpRespSimilarItemsFooter_viewer$data = PdpRespSimilarItemsFooter_viewer;
export type PdpRespSimilarItemsFooter_viewer$key = {
    readonly " $data"?: PdpRespSimilarItemsFooter_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsFooter_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "FragmentSpread",
  "name": "PdpRespSimilarItemsGrid_similarItems",
  "args": null
};
return {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsFooter_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "similarItems"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "isArt",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": 8
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "similarItems",
      "name": "__PdpRespSimilarItemsFooter_similarItems_connection",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Literal",
          "name": "seller",
          "value": "EXCLUDE"
        }
      ],
      "concreteType": "moreLikeThisItemConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "moreLikeThisItemEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                (v1/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "startCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalResults",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isArt",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "visuallySimilarGridItems",
          "name": "visualSearch",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 6
            },
            {
              "kind": "Variable",
              "name": "itemPk",
              "variableName": "itemId"
            }
          ],
          "concreteType": "VisualSearchConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "VisualSearchEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Item",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_viewer",
      "args": null
    }
  ]
};
})();
(node as any).hash = 'b44f117a648b77e41c8e2de5b55aea33';
export default node;
